const uri =  {
    GET_TOKEN: 'Auth/GenerateToken',
    GET_FIND_GDC: 'User/FindGdc',
    GET_FIND_USER: 'User/FindUser',
    GET_BOOK_LIST: 'Master/BookList',
    GET_SUBJECT_LIST: 'Master/SubjectList',
    GET_TOPIC_LIST: 'Master/TopicList',
    GET_CONDITION_LIST: 'Master/ConditionList',
    GET_BOOK_CODE: 'Master/BookCode',
    GET_PERMISSION_LIST: 'Master/PermissionList',
    GET_MASTER_PERMISSION_GROUP: 'Master/PermissionGroup',
    POST_MEMBER_INFO: 'Master/CustomMemberInfo',
    POST_AUTHORIZE: 'Master/CustomAuthorize',
    POST_UPLOAD_DOA: 'Upload/UploadDoa',
    GET_ROLE: 'User/GetRole',
    GET_CLONE_BOOK: 'Book/CloneBook',
    POST_CREATE_BOOK: 'Book/CreateBook',
    POST_UPDATE_BOOK: 'Book/UpdateBook',
    GET_BOOK_RELEASE: 'Book/BookRelease',
    GET_DOA_EXCEPTION: 'Master/DoaException',
    GET_TOPIC_LIST_BY_BOOK: 'Manage/TopicListByBookReleaseId',
    GET_VERIFY_TOPIC: 'Manage/VerifyTopic',
    POST_UPDATE_DOA: 'Upload/UpdateDoa',
    GET_CHECKOUT_LIST: 'Checkout/List',
    GET_CHECKOUT_DETAIL: 'Checkout/Detail',
    GET_CHECKOUT_UNLOCK: 'Checkout/UnLock',
    GET_GROUP: 'Manage/Group',
    POST_UPDATE_GROUP: 'Manage/UpdateGroup',
    GET_GROUP_DETAIL: 'Manage/GroupDetail',
    GET_PERMISSION_GROUP: 'Manage/GetPermissionGroup',
    POST_UPDATE_PERMISSION_GROUP: 'Manage/UpdatePermissionGroup',
    GET_BOOK_GROUP: 'Manage/GetBookGroup',
    POST_ADD_BOOK_GROUP: 'Manage/AddBookGroup',
    POST_DELETE_BOOK_GROUP: 'Manage/DeleteBookGroup',
    GET_USER_GROUP: 'Manage/GetUserGroup',
    POST_ADD_USER_GROUP: 'Manage/AddUserGroup',
    POST_DELETE_USER_GROUP: 'Manage/DeleteUserGroup',
    GET_PERMISSION: 'Manage/GetPermission',
    GET_FIND_APPROVER: 'Manage/FindApprover',
    POST_CHECK_IN_DOA: 'Manage/CheckinDoa',
    GET_SEARCH_REQUEST: 'Manage/SearchRequest',
    GET_SEARCH_REQUEST_ADMIN: 'Manage/SearchRequestAdmin',
    GET_REQUEST_DETAIL: 'Manage/RequestDetail',
    GET_REQUEST_DETAIL_EXCEL: 'Manage/RequestExcel',
    POST_ACTION: 'Manage/Action',
    POST_MULTI_ACTION: 'Manage/MultiAction',
    GET_HISTORY: 'Manage/GetHistory',
    GET_STATUS: 'Manage/GetStatus',
    GET_CONFIGURATION: 'Manage/GetConfiguration',
    POST_CONFIGURATION: 'Manage/Configurations',
    POST_UPDATE_NOTE: 'Manage/UpdateNote',
    GET_REQUEST: 'Manage/GetRequest',
    GET_REFERENCE_REQUEST: '/Manage/GetReferenceRequest',
    //GetRequestServerVar: '/Manage/GetRequestServerVar'
    POST_VERIFY_TOKEN: 'Auth/VerifyToken',
    POST_VERIFY_TOKEN_STEP2: 'Auth/VerifyTokenStepTwo',
}

export default uri;